import { FlagCountry, RegionType } from "../../../types";
import { i18n, i18nRich } from "../../i18n";
import { FlagIcon } from "../FlagIcon";
import { Icon } from "../Icon";
import { closeModal } from "./Modal";

declare let window: ProductPage;

export const LocalPlusModalContent = () => {
  const { shippingFromCountryCode, shippingFromCountryName } =
    window.retailerInformation;
  const { regionType } = window.localPlusShippingFeature;
  const { currentCountry } = window;

  return (
    <>
      <article className="tw:p-4 tw:pt-0 local-plus-modal">
        <h2 className="text-center local-plus-modal__title">
          {i18nRich(
            "local-plus.confirmed-shipping.title",
            <Icon name="location" aria-hidden="true" />
          )}
        </h2>
        <p>{i18n("local-plus.fast-track")}</p>
        <p>{i18n("local-plus.stocked")}</p>
        {(regionType === RegionType.WithinEU ||
          regionType === RegionType.WithinSameCountry) && (
          <p>
            {i18n("local-plus.benefits")}
            {regionType === RegionType.WithinSameCountry &&
              currentCountry === "GB" && (
                <span>{i18n("local-plus.northen-ireland")}</span>
              )}
          </p>
        )}
        <div className="local-plus-modal__wrapper">
          <ul className="local-plus-modal__list">
            <li>
              <Icon name="verified" fill="#4a81f2" />
              <p className="local-plus-modal__list-container m-0">
                {regionType === RegionType.WithinSameCountry &&
                  i18nRich(
                    "local-plus.confirmed-shipping",
                    <strong class="local-plus-modal__country">
                      <FlagIcon
                        country={shippingFromCountryCode as FlagCountry}
                        aria-hidden="true"
                      />
                      {shippingFromCountryName}
                    </strong>
                  )}
                {(regionType === RegionType.WithinEU ||
                  regionType === RegionType.WithinLocalRegion) &&
                  i18nRich(
                    "local-plus.confirmed-shipping",
                    <strong class="local-plus-modal__name">
                      Local+ <Icon name="location" aria-hidden="true" />
                    </strong>
                  )}
              </p>
            </li>
            <li>
              <Icon name="verified" fill="#4a81f2" aria-hidden="true" />
              <p
                className="m-0"
                dangerouslySetInnerHTML={{
                  __html: i18n("local-plus.smooth-experience"),
                }}
              />
            </li>
            {regionType !== RegionType.WithinLocalRegion && (
              <li>
                <Icon name="verified" fill="#4a81f2" aria-hidden="true" />
                <p
                  className="m-0"
                  dangerouslySetInnerHTML={{
                    __html: i18n("local-plus.customs-fees"),
                  }}
                />
              </li>
            )}
          </ul>
        </div>
      </article>
      <footer>
        <button
          className="button button-secondary mb-16 mb-sm-0"
          onClick={() => closeModal()}
        >
          {i18n("search.page.close")}
        </button>
      </footer>
    </>
  );
};
